import React, { useEffect } from 'react';
import { Route, Switch } from 'react-router-dom';

import { initialRoutes as PublicRoutes } from './PublicRoutes';
import PrivacyPolicy from '~/components/layout/PrivacyPolicy';
import ModalLGPD from '~/components/layout/LGPD';
import CompetitiveTraining from '~/components/layout/CompetitiveTraining';
import SignIn from '~/pages/Auth/SingIn';
import Portal from '~/pages/Portal';
import MyAccount from '~/pages/MyAccount';
import Bankslips from '~/pages/Bankslips';
import Invoices from '~/pages/Invoices';
import GasVoucherDetail from '~/pages/GasVoucherDetail';
import GasVoucherList from '~/pages/GasVoucherList';
import GasVoucherLinks from '~/pages/GasVoucherLinks';
import GasVoucherValidation from '~/pages/GasVoucherValidation';
import Faq from '~/pages/Faq';
import SegmentedComunication from '~/pages/SegmentedComunication';
import SegmentedComunicationDetails from '~/pages/SegmentedComunication/Details';
import Training from '~/pages/Training';
import VideoPage from '~/pages/TrainingVideo';
import ListStatus from '~/pages/OrderList';
import StatusOrder from '~/pages/OrderDetail';
import Order from '~/pages/Order';
import EditOrder from '~/components/pages/Order/Edit';
import ChangeName from '~/pages/ChangeName';
import OrderChecklist from '~/pages/OrderChecklist';
import OrderChecklistDetail from '~/components/pages/OrderChecklist/Answer';
import ShoppingClub from '~/pages/ShoppingClub';
import EmployeeList from '~/pages/EmployeeList';
import Employee from '~/pages/Employee';
import Contracts from '~/pages/Contracts';
import OrderEdit from '~/pages/OrderEdit';
import OrderEditOrder from '~/components/pages/OrderEdit/Edit';
import Dashboard from '~/pages/Dashboard';
import Consultant from '~/pages/Consultant';
import HistoryVisits from '~/pages/HistoryVisits';
import Pendencies from '~/pages/Pendencies';
import NotificationPopup from '~/pages/SegmentedComunication/NotificationPopup';
import NotificationPush from '~/pages/SegmentedComunication/NotificationPush';
import InitialOrder from '~/pages/Logistic/InitialOrder';
import FinancialComposition from '~/pages/Logistic/FinancialComposition';
import FinancialDiscount from '~/pages/Logistic/FinancialDiscount';
import SubsidizedContainers from '~/pages/Logistic/SubsidizedContainers';
import ResumeOrder from '~/pages/Logistic/ResumeOrder';
import ResultOrder from '~/pages/Logistic/ResultOrder';
import PreviousDebt from '~/pages/Logistic/PreviousDebt';
import PayDebt from '~/pages/Logistic/PayDebt';
import CashPayment from '~/pages/Logistic/CashPayment';
import PixPayment from '~/pages/Logistic/PixPayment';
import OrderList from '~/pages/Logistic/OrderList';
import OrderDetail from '~/pages/Logistic/OrderDetail';
import OrderChecklistCondition from '~/pages/Logistic/OrderChecklist';
import LapidarPage from '~/pages/Lapidar/LapidarPage';
import Marketing from '~/pages/Marketing';

export let initialRoutes = [
  { path: '/', component: SignIn },
  {
    path: '/portal',
    component: () =>
    <>
      <NotificationPopup />
      <CompetitiveTraining />
      <ModalLGPD
        showModal={localStorage.getItem("lgpd") === "false" ? true : false}
        activeModal={() => false}
        user={{ userId: localStorage.getItem("userId") }}
      />
      <PrivacyPolicy
        showModal={localStorage.getItem("privacyPolicy") === "false" ? true : false}
        activeModal={() => false}
        user={{ userId: localStorage.getItem("userId") }}
      />
      <Portal />
      <NotificationPush />
    </>
  },
  {
    path: '/minha-conta',
    component: () =>
    <>
      <MyAccount />
      <NotificationPush />
    </>
  },
  {
    path: '/boletos',
    component: () =>
    <>
      <Bankslips />
      <NotificationPush />
    </>
  },
  {
    path: '/pendencias',
    component: () =>
    <>
      <Pendencies />
      <NotificationPush />
    </>
  },
  {
    path: '/notas',
    component: () =>
    <>
      <Invoices />
      <NotificationPush />
    </>
  },
  {
    path: '/valegas/view',
    component: () =>
    <>
      <GasVoucherDetail />
      <NotificationPush />
    </>
  },
  {
    path: '/valegas',
    component: () =>
    <>
      <GasVoucherLinks />
      <NotificationPush />
    </>
  },
  {
    path: '/valegas/relatorio',
    component: () =>
    <>
      <GasVoucherList />
      <NotificationPush />
    </>
  },
  {
    path: '/valegas/validar',
    component: () =>
    <>
      <GasVoucherValidation />
      <NotificationPush />
    </>
  },
  {
    path: '/universidade-ultragaz',
    component: () =>
    <>
      <Faq />
      <NotificationPush />
    </>
  },
  {
    path: '/segmented-comunication',
    component: () =>
    <>
      <SegmentedComunication />
      <NotificationPush />
    </>
  },
  {
    path: '/segmented-comunication-details',
    component: () =>
    <>
      <SegmentedComunicationDetails />
      <NotificationPush />
    </>
  },
  {
    path: '/treinamentos',
    component: () =>
    <>
      <Training />
      <NotificationPush />
    </>
  },
  {
    path: '/treinamentos/video',
    component: () =>
    <>
      <VideoPage />
      <NotificationPush />
    </>
  },
  {
    path: '/status',
    component: () =>
    <>
      <ListStatus />
      <NotificationPush />
    </>
  },
  {
    path: '/status-pedido',
    component: () =>
    <>
      <StatusOrder />
      <NotificationPush />
    </>
  },
  {
    path: '/pedidos',
    component: () =>
    <>
      <Order />
      <NotificationPush />
    </>
  },
  {
    path: '/editar-pedido',
    component: () =>
    <>
      <EditOrder />
      <NotificationPush />ço
    </>
  },
  {
    path: '/editar-pedido-abastecimento',
    component: () =>
    <>
      <OrderEditOrder />
      <NotificationPush />
    </>
  },
  {
    path: '/criar-pedido',
    component: () =>
    <>
      <InitialOrder />
      {/* <NotificationPush />  TODO: UNCOMENTED*/}
    </>
  },
  // TODO - RETIRAMOS A TELA DE VALIDAÇÃO DE VEICULOS
  // {
  //   path: '/validar-veiculo-para-transporte',
  //   component: () => <TransportVehicle />
  // },
  //TODO challenge-lapidar
  {
    path: '/lapidar*',
    component: () => <LapidarPage />
  },
  {
    path: '/composicao-financeira-reposicoes',
    component: () => <FinancialComposition />

  },
  {
    path: '/composicao-financeira-descontos',
    component: () => <FinancialDiscount />
  },
  {
    path: '/vasilhames-subsidiados',
    component: () =>  <SubsidizedContainers />
  },
  {
    path: '/resumo-do-pedido',
    component: () => <ResumeOrder />
  },
  {
    path: '/pedido-recebido',
    component: () => <ResultOrder />
  },
  {
    path: '/necessario-quitar-debito',
    component: () => <PreviousDebt />
  },
  {
    path: '/pagar-debito-anterior',
    component: () =>
    <>
      <PayDebt />
      {/* <NotificationPush /> */}
    </>
  },
  {
    path: '/pagamento-a-vista',
    component: () =>
    <>
      <CashPayment />
      {/* <NotificationPush /> */}
    </>
  },
  {
    path: '/pagamento-via-pix',
    component: () =>
    <>
      <PixPayment />
      {/* <NotificationPush /> */}
    </>
  },
  {
    path: '/lista-de-pedidos',
    component: () => <OrderList />
  },
  {
    path: '/detalhes-do-pedido',
    component: () => <OrderDetail />
  },
  {
    path: '/condicao-carregamento',
    component: () =>
    <>
      <OrderChecklistCondition />
      {/* <NotificationPush /> */}
    </>
  },
  {
    path: '/editar-perfil',
    component: () =>
    <>
      <ChangeName />
      <NotificationPush />
    </>
  },
  {
    path: '/confirmacao-pedido',
    component: () =>
    <>
      <OrderChecklist />
      <NotificationPush />
    </>
  },
  {
    path: '/confirmacao-pedido/info',
    component: () =>
    <>
      <OrderChecklistDetail />
      <NotificationPush />
    </>
  },
  {
    path: '/portal-de-compras',
    component: () =>
    <>
      <ShoppingClub />
      <NotificationPush />
    </>
  },
  {
     path: '/usuarios',
     component: () =>
     <>
       <EmployeeList />
       <NotificationPush />
     </>
  },
  {
    path: '/cadastrar-funcionario',
    component: () =>
    <>
      <Employee />
      <NotificationPush />
    </>
  },
  {
    path: '/contratos',
    component: () =>
    <>
      <Contracts />
      <NotificationPush />
    </>
  },
  {
    path: '/edição-pedido',
    component: () =>
    <>
      <OrderEdit />
      <NotificationPush />
    </>
  },
  {
    path: '/trocas',
    component: () =>
    <>
      <Dashboard />
      <NotificationPush />
    </>
  },
  {
    path: '/consultor-comercial',
    component: () =>
    <>
      <Consultant />
      <NotificationPush />
    </>
  },
  {
    path: '/historico-visitas',
    component: () =>
    <>
      <HistoryVisits />
      <NotificationPush />
    </>
  },
  {
    path: '/marketing',
    component: () =>
    <>
      <Marketing />
      <NotificationPush />
    </>
  },
];

PublicRoutes.map(route => {
  initialRoutes.push(route);
});

export const PrivateRoutes = () => {
  useEffect(() => {
    if(window.location.pathname !== "/portal" &&
    localStorage.getItem("privacyPolicy") === "false") {
      window.location.pathname = "/portal";
    }
  }, []);

  return (
    <Switch>
      {initialRoutes.map((route, idx) => {
        return route.component ? (
          <Route
            exact
            key={idx}
            path={route.path}
            component={route.component}
          />
        ) : null;
      })}
    </Switch>
  );
};
